<template>
  <div class="home">
    <!-- Header -->
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="router"></Header>
    <!-- banner -->
    <div class="banner-bg">
      <div class="banner-box">
        <div class = "banner-text">
          <div class="banner-title">低代码赋能企业加快数字化转型步伐</div>
          <div class="banner-desc">80%的企业与机构对业务需求的敏捷响应、高效低成本的开发与运维有着强烈的需求，而在这其中，越来越多企业与机构的领导者在IT建设以及数字化转型探索中，会考虑利用低代码/零代码产品支持技术人员、业务人员的敏捷实践。</div>
        </div>
      </div>
    </div>
    <div class="areaArticle">
      <div ref="breadcrumb">
        <el-breadcrumb class="list" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item class="point" @click.native="jumpFrontier">前沿</el-breadcrumb-item>
          <el-breadcrumb-item v-if="tag !== ''">
            {{ tag }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row class="menuArea" v-show="tag === ''">
        <div class="menu information" :class="channelId === 291 ? 'information_active': ''" @click="changeMenu(291)">新闻动态</div>
        <div class="menu technical" :class="channelId === 292 ? 'technical_active': ''" @click="changeMenu(292)">行业资讯</div>
      </el-row>
      <el-row class="container" :style="containerStyle">
        <el-col :span="15">
          <frontier-about-article ref="aboutArticle" :tag="tag" :tag-info="tagInfo" @openDetail="openDetail" @jumpTag="jumpTag"></frontier-about-article>
        </el-col>
        <el-col :span="9" class="containerRight">
          <frontier-right-page @jumpTag="jumpTag" @openDetail="openDetail"></frontier-right-page>
        </el-col>
      </el-row>
    </div>

    <!--联系专家-->
    <ContactExperts></ContactExperts>
    <!-- footer -->
    <FhBottom/>
<!--    <Footer></Footer>-->
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
  import Header from './include/Header.vue';
  import Footer from './include/Footer.vue';
  import HussarForm from "./include/HussarForm";
  import ContactExperts from './include/ContactExperts.vue';
  import SideBar from "./include/SideBar";
  import FrontierAboutArticle from "./FrontierAboutArticle";
  import FrontierDetailsArticle from "./FrontierDetailsArticle";
  import FrontierRightPage from "./FrontierRightPage";
  import router from '@/router/index.js'
  let routerName = "";
  let tagData = "";
  export default {
    name: "FrontierPage",
    data() {
      return {
        router:'/FrontierPage',
        headColor:"light",
        isPageScroll: false,
        showForm: false,
        article:[],
        id:0,
        articleHot: [],
        articleRead: [],
        articleRelevance: [],
        tagHot: [],
        tag:'', //选中的标签
        tagInfo: [],
        channelId: 291, //  291新闻动态  292行业资讯
        containerStyle: {paddingTop: '25px'}, //样式
      };
    },
    components: {
      FrontierRightPage,
      FrontierDetailsArticle,
      FrontierAboutArticle,
      Header,
      HussarForm,
      Footer,
      SideBar,
      ContactExperts,
    },
    watch: {

    },
    methods: {
      changeMenu(channelId) {
        const self = this;
        if(channelId !== self.channelId){
          self.channelId = channelId
          this.$refs['aboutArticle'].getFrontier(1,'',channelId)
        }
      },
      jumpFrontier() {
        this.tag = ""
        this.$refs['aboutArticle'].getFrontier(1,'1')
      },
      jumpTag(item) {
        this.$nextTick(() => {
          this.$root.frontierTag = item;
          this.$router.push(`/FrontierPage/aboutArticle=${item.id}`);
          // router.push({name:'FrontierSelectPage',params:{'tagData': JSON.stringify(item)}})
        })
      },
      openForm() {
        const self = this;
        self.showForm = true;
      },
      closeForm() {
        const self = this;
        self.showForm = false;
      },
      // 页面滚动
      handleNavScroll() {
        const self = this;
        self.isPageScroll = false;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 80) {
          self.isPageScroll = true;
          self.headColor = 'dark';
        }else{
          self.headColor = 'light';
        }
      },
      // 返回顶部
      backTop() {
        $('html ,body').animate({scrollTop: 0}, 700);
      },
      //打开详情
      openDetail(item) {
        this.$root.frontierArticle = item;
        this.$root.channelId = this.channelId;
        localStorage.setItem('channelId', '')
        this.$router.push(`/FrontierPage/detailsArticle=${item.id}`);
        // router.push({name:'FrontierDetailsArticle',params:{article: item,channelId: this.channelId,tagData: ''}});
      },
    },
    mounted() {
      const self = this;
      window.addEventListener('scroll', self.handleNavScroll);
    },
    created() {
    },
  }
</script>

<style scoped>
  .home {color: #2E2E2E;background: #ffffff}
  .banner-bg{background: linear-gradient(to right, #409EFE 0%, #409EFE 50%, #0647E9 50%, #0647E9 100%);}
  .banner-box{width:100%;height:458px;background: url("../assets/img/frontierPage/banner-bg.png"); background-position: 50%;background-repeat: no-repeat;}
  .banner-text{width:1200px;color: #FFFFFF;text-align: left;padding-top:184px;padding-bottom: 100px;margin:  0 auto;}
  .banner-title{font-size: 48px;font-weight: bold;}
  .banner-desc{font-size: 16px;font-weight: 400;margin-top: 27px; width: 636px; line-height: 30px}
  /* 返回顶部 */
  .back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
  /* 前沿资讯 */
  .areaArticle {padding-bottom: 42px;width: 1200px;margin: auto;}
  .areaArticle .container .containerRight {padding-left: 80px;}
  .list {font-size: 14px;font-weight: 400;color: #A7A7A7;margin-top: 42px;}
  .list /deep/ .el-breadcrumb__item .el-breadcrumb__inner {color: #a7a7a7 !important;font-weight: 400;}
  .list /deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner {color: #0e0d0d !important;}
  .point {cursor: pointer}
  .menuArea{margin-top: 25px}
  .menu {font-size: 16px;float: left;height: 44px;line-height: 44px;width: 128px;cursor: pointer}
  .information {background: url('~@/assets/img/frontierPage/white-left.png');background-size: 100%;padding-left: 21px;color: #707070}
  .information_active {background: url('~@/assets/img/frontierPage/blue-left.png');background-size: 100%;color: #ffffff}
  .technical {background: url('~@/assets/img/frontierPage/white-right.png');background-size: 100%;text-align: right;padding-right: 23px;color: #707070;margin-left: -28px;margin-top: 10px}
  .technical_active {background: url('~@/assets/img/frontierPage/blue-right.png');background-size: 100%;color: #ffffff}
  .home >>>.header-box{background: rgba(255, 255, 255, 0);}
  .home >>>.header-fixed {position: fixed;background: rgba(255, 255, 255, 1);z-index: 99;transition: all .45s ease;}
  .home >>> .navigator > div a:hover,.navigator .isActive {color: #186CF5;}
  .home >>>.nav-light >.navigator .isActive{color: #fff}9
  .home >>>.nav-light >.navigator .isActive::after{background: #fff}
</style>




// WEBPACK FOOTER //
// src/components/FrontierPage.vue